import { render, staticRenderFns } from "./newVehicleCardComponent.vue?vue&type=template&id=0fb40397"
import script from "./newVehicleCardComponent.vue?vue&type=script&lang=js"
export * from "./newVehicleCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports